import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const supportedLanguages = ['en', 'de-CH', 'fr-CH', 'it-CH'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    ns: ['common', 'forms', 'navigation', 'errors'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'loomis_language',
    },
    react: {
      useSuspense: true, // Enable suspense mode for proper async handling
    },
    debug: process.env.NODE_ENV === 'development', // Enable debug logging in development
  });

export default i18n;
